<template>
  <section class="privacy-policy-page">
    <div class="container">
      <div class="policy-header text-center">
        <h1>Terms and Service</h1>
      </div>

      <div class="policy-content" v-html="termsOfService"></div>
    </div>
  </section>
</template>

<script>
import api from '@/services/api'
export default {
  data() {
    return {
        termsOfService:''
    }
  },
  mounted() {
    this.fetchTermsOfService()
  },
  methods:{
    async fetchTermsOfService() {
        try {
            const response = await api.get('/api/cms/terms-service')
            this.termsOfService = response.data.termsOfService || ''
        } catch (error) {
            console.error('Error fetching terms and services:', error)
            this.policyContent = '<p>Loading failed. Please try again.</p>'
        }
    }
  }
}
</script>

<style scoped>
.privacy-policy-page {
  padding: 60px 0;
  background-color: #f9f9f9;
  color: #333;
  line-height: 1.8;
  font-size: 16px;
}

.container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 20px;
}

.policy-header {
  margin-bottom: 50px;
}

.policy-header h1 {
  font-size: 2.5rem;
  color: #2C5C9E;
  margin-bottom: 10px;
}

.last-updated {
  color: #666;
  font-style: italic;
}

.policy-content {
  text-align: left;
  background: white;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  margin-bottom: 40px;
}

.policy-content >>> h2 {
  color: #2C5C9E;
  margin: 40px 0 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #eee;
  font-size: 1.5rem;
}

.policy-content >>> ul {
  padding-left: 20px;
  margin: 15px 0;
}

.policy-content >>> li {
  margin-bottom: 10px;
}

.policy-content >>> a {
  color: #2C5C9E;
  text-decoration: none;
  transition: color 0.3s;
}

.policy-content >>> a:hover {
  color: #1a3d6b;
  text-decoration: underline;
}

.contact-section {
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
}

.contact-section h2 {
  color: #2C5C9E;
  margin-bottom: 20px;
}

.contact-details {
  list-style: none;
  padding-left: 0;
  margin-top: 20px;
}

.contact-details li {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}

.contact-details i {
  margin-right: 15px;
  color: #2C5C9E;
  width: 20px;
  text-align: center;
}

.contact-details a {
  color: #2C5C9E;
  text-decoration: none;
  transition: color 0.3s;
}

.contact-details a:hover {
  color: #1a3d6b;
  text-decoration: underline;
}

@media (max-width: 767px) {
  .privacy-policy-page {
    padding: 40px 0;
  }
  
  .policy-header h1 {
    font-size: 2rem;
  }
  
  .policy-content {
    padding: 25px;
  }
  
  .policy-content >>> h2 {
    font-size: 1.3rem;
  }
}
</style>